"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reviews = void 0;
exports.reviews = {
    trustpilot: 'https://www.trustpilot.com/review/feather-insurance.com',
    google: 'https://www.google.com/search?q=feather+insurance&ei=7IWjYKjjKszQaIDQroAL&oq=feather+insurance&gs_lcp=Cgdnd3Mtd2l6EAMyAggAOgcIABBHELADOgQIABBDUKYnWLw9YLpFaAFwAngAgAG2AogB9QqSAQcwLjcuMC4xmAEAoAEBqgEHZ3dzLXdpesgBCMABAQ&sclient=gws-wiz&ved=0ahUKEwioiZzS8tLwAhVMKBoKHQCoC7AQ4dUDCA4&uact=5#lrd=0x47a84f408d3fac27:0x76b64d5066963c2e,1',
};
